import {
    SET_CMS_PAGES
} from "./constants";
import {svcPsService} from "../../../_services/ps-service";
import {globalCatch} from "../../../_services/global-catch";


export const fetchCmsPages = (pageIds) => globalCatch.catch(async (dispatch) => {
    const cmsPages = await (await svcPsService()).getCmsPages(pageIds);
    dispatch(setCmsPages(cmsPages));
});

export const setCmsPages = payload => ({type: SET_CMS_PAGES, payload});